import { useState } from 'react';
import { Radio, RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

// First radio group (Weight loss plans) - Added 'procenat' to each object
const mailingLists1 = [
    { id: 1, title: 'Blago smanjenje', description: 'Cilj: Postepeni gubitak težine, obično 0.25-0.5 kg nedeljno', ideal: "Idealno za: Osobe koje žele sporiji, održiviji gubitak težine ili koje imaju manju količinu kilograma za gubljenje", users: 'Besplatno', procenat: 10 },
    { id: 2, title: 'Umereno smanjenje', description: 'Cilj: Umeren gubitak težine, obično 0.5-1 kg nedeljno', ideal: "Idealno za: Osobe koje teže bržem vidljivom gubitku težine u kratkom vremenskom okviru, dok istovremeno održavaju zdrav i održiv pristup.", users: 'Plaćena verzija', procenat: 20 },
    { id: 3, title: 'Agresivno smanjenje', description: 'Cilj: Brži gubitak težine, obično 1-1.5 kg nedeljno', ideal: "Idealno za: Osobe sa većim viškom kilograma koje žele brže rezultate, ali je važno napomenuti da ovakvo smanjenje može biti teže za održavanje na duži rok", users: 'Plaćena verzija', procenat: 30 },
];

// Second radio group (Exercise intensity levels)
const mailingLists2 = [
    { id: 1, title: 'Blago povećanje', description: 'Cilj: Postepeno dobijanje težine, obično 0.25-0.5 kg mesečno', ideal: "Idealno za: Osobe koje žele održiv i sporiji dobitak mišićne mase ili za one koji tek počinju sa dobijanjem težine.", users: 'Besplatno', procenat: 10 },
    { id: 2, title: 'Umereno povećanje:', description: 'Cilj: Umeren dobitak težine, obično 0.5-1 kg mesečno', ideal: "Idealno za: Osobe koje žele stabilan dobitak težine i mišićne mase, uz održavanje niske količine masti.", users: 'Plaćena verzija', procenat: 20 },
    { id: 3, title: 'Agresivno povećanje:', description: 'Cilj: Brži dobitak težine, obično 1-1.5 kg mesečno', ideal: "Idealno za: Osobe sa većim ciljevima za dobitak težine, kao što su bodibilderi ili oni koji žele brzo povećanje telesne mase.", users: 'Plaćena verzija', procenat: 30 },
];

function Radios() {
  // First set of radio buttons state
  const [selectedMailingLists1, setSelectedMailingLists1] = useState(mailingLists1[0]);
  const [areButtonsEnabled1, setAreButtonsEnabled1] = useState(false);
  const [baseValue1, setBaseValue1] = useState(390); // Example base value for first group
  const [calculatedValue1, setCalculatedValue1] = useState((mailingLists1[0].procenat / 100) * baseValue1);

  // Second set of radio buttons state
  const [selectedMailingLists2, setSelectedMailingLists2] = useState(mailingLists2[0]);
  const [areButtonsEnabled2, setAreButtonsEnabled2] = useState(false);
  const [baseValue2, setBaseValue2] = useState(500); // Example base value for second group
  const [calculatedValue2, setCalculatedValue2] = useState((mailingLists2[0].procenat / 100) * baseValue2);

  const toggleButtonState1 = () => {
    setAreButtonsEnabled1((prevState) => !prevState);
  };

  const toggleButtonState2 = () => {
    setAreButtonsEnabled2((prevState) => !prevState);
  };

  const handleMailingListChange1 = (mailingList) => {
    setSelectedMailingLists1(mailingList);
    const newCalculatedValue = (mailingList.procenat / 100) * baseValue1;
    setCalculatedValue1(newCalculatedValue);
  };

  const handleMailingListChange2 = (mailingList) => {
    setSelectedMailingLists2(mailingList);
    const newCalculatedValue = (mailingList.procenat / 100) * baseValue2;
    setCalculatedValue2(newCalculatedValue);
  };

  //Za radio zeljnei cilj
  // Definisanje state varijabli
  const [selectedPlan, setSelectedPlan] = useState("mrsavljenje"); // Plan: mršavljenje ili gojenje
  const [selectedMonth, setSelectedMonth] = useState(1); // Početna vrednost za mesec
  const [brKilaDaSePromeni, setBrKilaDaSePromeni] = useState(""); // Početna vrednost za željeni gubitak ili dobitak kilograma
  const [kilazaIspisana, setKilazaIspisana] = useState(70); // Početna vrednost trenutne težine

  // Funkcija za promenu izabrane vrednosti meseca
  const handleChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  // Funkcija za promenu plana (mršavljenje ili gojenje)
  const handlePlanChange = (event) => {
    setSelectedPlan(event.target.value);
    setBrKilaDaSePromeni(""); // Resetovanje unosa kilograma pri promeni plana
  };

  // Funkcija za izračunavanje krajnjeg datuma na osnovu broja meseci
  const calculateDate = () => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + parseInt(selectedMonth));
    return currentDate.toLocaleDateString("sr-RS");
  };

  // Funkcija za izračunavanje ciljne težine na kraju odabranog perioda
  const calculateTargetWeight = () => {
    const targetWeight =
      selectedPlan === "mrsavljenje"
        ? kilazaIspisana - (brKilaDaSePromeni || 0)
        : kilazaIspisana + (brKilaDaSePromeni || 0);
    return targetWeight > 0 ? targetWeight : 0; // Osiguravamo da težina ne bude negativna
  };

  // Funkcija za izračunavanje dnevnog kalorijskog deficita ili viška
  const calculateDailyChange = () => {
    const changePerKg = 7700; // Promena kalorija po kilogramu
    const daysInMonth = 30; // Broj dana u mesecu
    const change = (brKilaDaSePromeni * changePerKg) / (selectedMonth * daysInMonth);
    return Math.round(change);
  };

  // Sprečavanje unosa negativnih brojeva za željeni gubitak ili dobitak kilograma
  const handleWeightChange = (e) => {
    const value = e.target.value;
    if (value === "" || value === "-") {
      setBrKilaDaSePromeni(""); // Ako je prazno polje ili se unese "-", ostavi prazno
    } else {
      setBrKilaDaSePromeni(Math.max(0, value)); // Sprečava negativne vrednosti
    }
  };


  return (
    <div>

    <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
      <legend className="text-2xl font-bold text-gray-900 mb-4">Plan za mršavljenje i gojenje</legend>

      {/* Izbor između mršavljenja i gojenja */}
      {/* <div className="flex items-center mb-6">
        <label className="text-md font-medium text-gray-700 mr-4">Izaberite plan:</label>
        <div className="flex space-x-4">
          <label className="flex items-center">
            <input
              type="radio"
              value="mrsavljenje"
              checked={selectedPlan === "mrsavljenje"}
              onChange={handlePlanChange}
              className="form-radio text-blue-600"
            />
            <span className="ml-2 text-gray-700">Mršavljenje</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              value="gojenje"
              checked={selectedPlan === "gojenje"}
              onChange={handlePlanChange}
              className="form-radio text-blue-600"
            />
            <span className="ml-2 text-gray-700">Gojenje</span>
          </label>
        </div>
      </div> */}

      {/* Prikaz odabira trajanja meseca */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="flex flex-col">
          <label className="text-md font-medium text-gray-700">Trajanje perioda (u mesecima):</label>
          <select
            value={selectedMonth}
            onChange={handleChange}
            className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            {[1, 2, 3, 4, 5, 6].map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-md font-medium text-gray-700">
            Predviđeni datum postizanja cilja:
          </label>
          <span className="mt-2 text-lg font-semibold text-blue-600">
            {calculateDate()}
          </span>
        </div>
      </div>

      {/* Unos željene kilaže */}
      <div className="mt-6">
        <label className="text-md font-medium text-gray-700">
          {selectedPlan === "mrsavljenje"
            ? "Željeni broj kilograma za mršavljenje:"
            : "Željeni broj kilograma za gojenje:"}
        </label>
        <div className="flex items-center space-x-4 mt-2">
          <input
            type="number"
            name="brKilaDaSePromeni"
            id="brKilaDaSePromeni"
            value={brKilaDaSePromeni}
            onChange={handleWeightChange}
            className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Unesite kg"
            min="0"
          />
          <span className="text-md font-medium text-gray-700">kg</span>
        </div>
      </div>

      {/* Ispisana trenutna kilaža */}
      <div className="mt-6">
        <label className="text-md font-medium text-gray-700">
          Vaša trenutna kilaža:{" "}
          <span className="font-semibold text-blue-600">{kilazaIspisana} kg</span>
        </label>
      </div>

      {/* Informacije o cilju */}
      <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Rezultati vašeg plana:</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <p className="text-md font-medium text-gray-700">
              Nakon <span className="font-semibold text-blue-600">{selectedMonth}</span>{" "}
              meseca, vaša ciljana težina biće{" "}
              <span className="font-semibold text-blue-600">{calculateTargetWeight()} kg</span>.
            </p>
          </div>
          <div>
            <p className="text-md font-medium text-gray-700">
              {selectedPlan === "mrsavljenje" ? "Dnevni deficit" : "Dnevni kalorijski višak"} kalorija:{" "}
              <span className="font-semibold text-blue-600">
                {brKilaDaSePromeni ? calculateDailyChange() : "N/A"}
              </span>{" "}
              kalorija po danu.
            </p>
          </div>
        </div>
      </div>
    </fieldset>



      {/* <div className="mb-6">
        <button onClick={toggleButtonState1} className="mb-4 px-4 py-2 bg-blue-600 text-white rounded">
          {areButtonsEnabled1 ? 'Disable Other Options' : 'Enable Other Options'}
        </button>

        <fieldset>
          <RadioGroup
            value={selectedMailingLists1}
            onChange={handleMailingListChange1}
            className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4"
          >
            {mailingLists1.map((mailingList) => (
              <Radio
                key={mailingList.id}
                value={mailingList}
                className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200
                  ${areButtonsEnabled1 || mailingList.id === 1 ? 'border border-gray-300 bg-white' : 'border border-gray-200 bg-gray-100 cursor-not-allowed'}
                  focus:outline-none`}
                disabled={!areButtonsEnabled1 && mailingList.id !== 1}
              >
                <span className="flex flex-1">
                  <span className="flex flex-col">
                    <span className="block text-sm font-medium text-gray-900">{mailingList.title}</span>
                    <span className="mt-1 flex items-center text-sm text-gray-500">{mailingList.description}</span>
                    <span className="mt-1 flex items-center text-sm text-gray-500">{mailingList.ideal}</span>
                    <span className="mt-6 text-sm font-medium text-gray-900">{mailingList.users}</span>
                  </span>
                </span>
                <CheckCircleIcon
                  aria-hidden="true"
                  className={`h-5 w-5 text-blue-600 ${areButtonsEnabled1 || mailingList.id === 1 ? '' : 'invisible'}`}
                />
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent 
                    group-data-[focus]:border group-data-[checked]:border-blue-600"
                />
              </Radio>
            ))}
          </RadioGroup>
        </fieldset>

        <div className="mt-4 text-gray-900">
          <span className="font-semibold">Calculated Percentage of {baseValue1}: </span>
          {calculatedValue1}
        </div>
      </div>

      <div>
        <button onClick={toggleButtonState2} className="mb-4 px-4 py-2 bg-blue-600 text-white rounded">
          {areButtonsEnabled2 ? 'Disable Other Options' : 'Enable Other Options'}
        </button>

        <fieldset>
          <RadioGroup
            value={selectedMailingLists2}
            onChange={handleMailingListChange2}
            className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4"
          >
            {mailingLists2.map((mailingList) => (
              <Radio
                key={mailingList.id}
                value={mailingList}
                className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200
                  ${areButtonsEnabled2 || mailingList.id === 1 ? 'border border-gray-300 bg-white' : 'border border-gray-200 bg-gray-100 cursor-not-allowed'}
                  focus:outline-none`}
                disabled={!areButtonsEnabled2 && mailingList.id !== 1}
              >
                <span className="flex flex-1">
                  <span className="flex flex-col">
                    <span className="block text-sm font-medium text-gray-900">{mailingList.title}</span>
                    <span className="mt-1 flex items-center text-sm text-gray-500">{mailingList.description}</span>
                    <span className="mt-1 flex items-center text-sm text-gray-500">{mailingList.ideal}</span>
                    <span className="mt-6 text-sm font-medium text-gray-900">{mailingList.users}</span>
                  </span>
                </span>
                <CheckCircleIcon
                  aria-hidden="true"
                  className={`h-5 w-5 text-blue-600 ${areButtonsEnabled2 || mailingList.id === 1 ? '' : 'invisible'}`}
                />
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent 
                    group-data-[focus]:border group-data-[checked]:border-blue-600"
                />
              </Radio>
            ))}
          </RadioGroup>
        </fieldset>

        <div className="mt-4 text-gray-900">
          <span className="font-semibold">Calculated Percentage of {baseValue2}: </span>
          {calculatedValue2}
        </div>
      </div> */}
    </div>
  );
}

export default Radios;
